import { DEFAULT_SPOKEN_STYLE } from '@edge/edge-ai'
import type { AnswerTierId } from './answer-tiers'

/**
 * Voice response tuning (Chris, 2026-08-28: "voice is too slow", refined:
 * no hard limit — salient AND concise). Chat and speech have DIFFERENT
 * contracts:
 *  - Chat: the chat principles ("be concise") + the effort chip
 *    (Fast/Normal/Heavy) — the user's knob.
 *  - Speech: the spoken-answer style block below — salience-first
 *    conciseness (lead with what matters, stop when nothing more changes
 *    the listener's understanding), plus the FAST analyst tier — depth
 *    belongs in chat, not in your ear.
 */

/**
 * The spoken-answer prompt block (manager `voiceStyle`). Edit or replace
 * this string to reshape how spoken answers sound — the edge-ai default is
 * re-exported so there is exactly one source of truth until it diverges.
 */
export const VOICE_STYLE_PROMPT = DEFAULT_SPOKEN_STYLE

/** Analyst tier for voice-modality questions, regardless of the effort chip. */
export const VOICE_ANALYST_TIER: AnswerTierId = 'fast'
